<template>
    <div class="modal-content">
        <div class="modal-header p-b-0">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
        </div>
        <div class="modal-body p-b-0 p-t-0">
            <div class="row m-b-20">
                <div class="col-xs-12">
                    <h3>Agilize seu contato com roommates no WebQuarto</h3>
                    <span>Salve algumas mensagens padrão em sua conta. Use as mensagens padrão para entrar em contato mais
                        rapidamente com inquilinos no WebQuarto.</span>
                </div>
            </div>

            <div class="row">
                <div class="col-sx-12" v-if="step == 0">
                    <p class="h5">Mensagens Salvas</p>

                    <ul class="list-unstyled">
                        <li class="m-b-15" v-for="msg, i in messages" v-bind:key="i">{{ msg.message | truncate(40) }}
                            <div class="pull-right">
                                <button @click="edit(msg)" type="button" class="btn btn-sm btn-white m-r-10">Editar</button>
                                <button @click="remove(msg)" type="button" class="btn btn-sm btn-white">Excluir</button>
                            </div>
                        </li>
                    </ul>

                    <div class="col-xs-12 text-center m-t-30">
                        <button @click="goToForm()" class="btn btn-success">Adicionar Nova</button>
                    </div>
                </div>

                <div class="col-xs-12" v-if="step == 1">
                    <p class="h5">Preencha sua Mensagem Padrão:</p>
                    <textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" placeholder="Digite sua mensagem neste campo" style="height: 120px"></textarea>
                    <button type="submit" @click="store()" class="m-t-20 btn btn-success btn-lg waves-effect waves-light ladda-button pull-right">
                        <span class="ladda-label">Salvar Mensagem</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                id: null,
                message: ''
            },
            step: 1,
            messages: []
        }
    },
    filters: {
        truncate: function(string, value) {
            if (string.length > value)
                return string.substring(0 , value) + '...';
            else
                return string;
        }
    },
    methods: {
        goToForm() {
            this.step = 1;
        },
        getList() {
            axios.get('/message/saved-messages').then(res => {
                this.messages = res.data.messages;
                if (this.messages.length > 0)
                    this.step = 0;
            });
        },
        store() {
            axios.post('/message/saved-message', this.form).then(res => {
                this.step = 0;
                location.reload();
            });
        },
        edit(obj) {
            this.form = {
                id: obj.id,
                message: obj.message
            };
            this.step = 1;
        },
        remove(obj) {
            this.messages = this.messages.filter(i => {
                return i.id != obj.id;
            });
            axios.post('/message/delete-saved-message', {id: obj.id});
        }
    },
    created() {
        this.getList();
    }
}
</script>

<style>

</style>